import { useState } from "react";
import { ImagePlus, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { uploadFile } from "@/lib/upload13";
import { useAuthedSrc } from "@/lib/authedImage";

const when = (s) => new Date(s).toLocaleString("en-US", { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

function Photo({ path, testid }) {
  const src = useAuthedSrc(path);
  return src ? <img src={src} alt="Handoff" className="h-28 w-28 rounded-lg object-cover" data-testid={testid} /> : <div className="h-28 w-28 animate-pulse rounded-lg bg-q-raised" />;
}

export function Notes({ base, hubBase, l, reload }) {
  const [text, setText] = useState("");
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const ids = [];
      for (const f of files) ids.push(await uploadFile(hubBase, f));
      await api.post(`${base}/notes`, { text, upload_ids: ids });
      setText(""); setFiles([]); toast.success("Handoff note added"); reload();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="max-w-2xl space-y-4" data-testid="cp-notes">
      {l.can_write && <div className="q-card space-y-3 p-4" data-testid="cp-note-form">
        <textarea className="q-input min-h-[88px] w-full" placeholder={`How did ${l.kid.name}'s time go? Anything ${l.other.name} should know?`} value={text} onChange={(e) => setText(e.target.value)} data-testid="cp-note-text" />
        <div className="flex flex-wrap items-center gap-2">
          <label className="q-btn q-btn-ghost min-h-[44px] cursor-pointer" data-testid="cp-note-photo-label"><ImagePlus className="h-4 w-4" /> Photos ({files.length}/3)
            <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => { const f = [...e.target.files].slice(0, 3); if (e.target.files.length > 3) toast.error("Up to 3 photos"); setFiles(f); }} data-testid="cp-note-photos" /></label>
          <button className="q-btn q-btn-primary ml-auto min-h-[44px]" disabled={busy || (!text.trim() && !files.length)} onClick={send} data-testid="cp-note-send"><Send className="h-4 w-4" /> {busy ? "Sending…" : "Add note"}</button>
        </div>
      </div>}
      <ul className="space-y-3">{l.notes.map((n) => (
        <li key={n.id} className={`q-card p-4 ${n.mine ? "" : "border-l-4"}`} style={n.mine ? {} : { borderLeftColor: l.other.color }} data-testid={`cp-note-${n.id}`}>
          <div className="text-xs text-q-faint">{n.by_name} · {n.hub_name} · {when(n.at)}</div>
          {n.text && <p className="mt-1 whitespace-pre-wrap break-words text-sm text-q-text">{n.text}</p>}
          {!!n.photos.length && <div className="mt-2 flex flex-wrap gap-2">{n.photos.map((p) => <Photo key={p} path={`${base}/notes/${n.id}/photos/${p}`} testid={`cp-note-photo-${p}`} />)}</div>}
        </li>))}
        {!l.notes.length && <li className="text-sm text-q-muted">No handoff notes yet.</li>}</ul>
    </div>
  );
}
